module.exports = __webpack_public_path__ + "img/mob4.9d06d21c.png";